import { createContext } from "react";

// A draw session opened above the question (by the intro screen, which shows
// its QR). DrawBoard mirrors it instead of opening a second one.
const SharedDrawHost = createContext(null);

export default SharedDrawHost;
